import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { Observable } from 'rxjs';

import { DeleteSiteLogo, LoadSiteLogo } from '../state/actions/site-logo.actions';

@Injectable({
  providedIn: 'root',
})
export class SiteLogoService {
  constructor(private readonly _store: Store<AppStateInterface>) {}
  //// Site Logo ////

  public loadSiteLogo(): Observable<string> {
    this._store.dispatch(new LoadSiteLogo());

    return this._store.select(({ siteLogo }: AppStateInterface) => siteLogo ? siteLogo.logoFileHref : '');
  }

  public updateSiteLogo(): void {
    this._store.dispatch(new LoadSiteLogo());
  }

  public deleteSiteLogo(): void {
    this._store.dispatch(new DeleteSiteLogo());
  }
}
